export default __webpack_public_path__ + "static/03f42206-6156-48ee-993d-1082ba29543a-8c034f8127b66ab59a3c42aca2bf92af.woff2";